// extracted by mini-css-extract-plugin
export default {"container":"TheLayout_container__Az3El"};